<template>
  <div>
    <h1>Entry type</h1>
    <FileWorking :file="file" />
    <v-alert :value="true" type="info" v-if="types && types.length > 0"
      >Choose the entry type you wish to add to the address book</v-alert
    >
    <v-alert :value="true" type="warning" v-if="types && types.length == 0"
      >There are no entry types to choose from</v-alert
    >
    <ul>
      <li v-for="type in types" :key="type.id">
        <a @click="navigate(type)">{{ type.name }}</a>
      </li>
      <li>
        <a @click="navigateTeam">Team</a>
      </li>
      <li>
        <a @click="navigateTeamFuture">Future team</a>
      </li>
    </ul>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import FileWorking from "@/components/link/FileWorking";
export default {
  name: "EntryType",
  metaInfo() {
    return {
      title: "Entry type",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  components: {
    FileWorking,
  },
  computed: {
    computedParams() {
      const relatedId = this.$route.params.relatedId
        ? this.$route.params.relatedId
        : undefined;
      return {
        objectType: this.$route.params.objectType,
        objectId: this.$route.params.objectId,
        relatedId,
      };
    },
  },
  data() {
    return {
      file: null,
      types: [],
    };
  },
  methods: {
    fetchFile() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.params.objectId}`)
        .then((response) => {
          // console.log(response.data);
          this.file = response.data;
        });
    },
    fetchTypes() {
      nbmlaw
        .get(`/cors/admin/directory/types/filtered/entrySearch`)
        .then((response) => {
          // console.log(response.data);
          this.types = response.data;
        });
    },
    navigate(type) {
      this.$router.push({
        name: "entrySearch",
        params: {
          ...this.computedParams,
          typeId: type.id,
        },
      });
    },
    navigateTeam() {
      this.$router.push({
        name: "teamAssign",
        params: this.computedParams,
      });
    },
    navigateTeamFuture() {
      this.$router.push({
        name: "teamFutureAssign",
        params: this.computedParams,
      });
    },
  },
  watch: {
    "$route.params.objectId": {
      immediate: true,
      handler() {
        this.fetchTypes();
        this.fetchFile();
      },
    },
  },
};
</script>
